<div class="carousel-loader__text-container">
  <p class="carousel-loader__text ci-heading-h6-s-bold">
    {{ 'Estamos creando tu ruta personalizada' | translate }}
  </p>
  <p class="carousel-loader__text ci-paragraph-p1-regular">
    {{ 'Espere unos segundos' | translate }}...
  </p>
</div>